<template>
  <b-container>
    <b-row align-h="between" style="margin-left: 0; margin-right: 0;">
      <h3>Benutzer:</h3>
      <div>
        <b-button variant="outline-primary" to="Einladung/Neu">Einladen</b-button>
      </div>
    </b-row>
    <hr class="mt-4 mb-4">
    <b-list-group-item
        v-for="user in users"
        :key="user.id"
        :to="{ path: `/Benutzer/${user.id}`}"
        class="flex-column align-items-start"
    >
      <div class="d-flex w-100 justify-content-between">
        <p class="mb-1 text-primary">
          {{ user.name }}
        </p>
      </div>
    </b-list-group-item>
  </b-container>
</template>

<script>
import {mapActions, mapGetters} from "vuex";

export default {
  name: "UserList",
  methods: {
    ...mapActions([
      'getUser'
    ])
  },
  mounted() {
    this.getUser()
  },
  computed: {
    ...mapGetters([
      'getStoredUser'
    ]),
    users() {
      return this.getStoredUser
    }
  }
}
</script>

<style scoped>

</style>
